import React from "react";
import TopNavbar from '../components/TopNavbar';
import International_countries from "./international_countries";
import { Outlet } from "react-router-dom";


const International = ( ) => {

    return (
        <div>
    <TopNavbar />
    <International_countries />     
   

      
  
     <Outlet />    
    </div>
  )
}
 
export default International;